// extracted by mini-css-extract-plugin
export default {"descriptionCell":"LogTab_descriptionCell__6LZni"};